import { BuildingIcon } from 'lucide-react';

interface CompanyHeaderProps {
  company: {
    name: string;
    subtitle: string;
  };
}

export function CompanyHeader({ company }: CompanyHeaderProps) {
  return (
    <div className="flex items-start gap-2">
      <div className="mt-0.5 rounded-lg bg-muted p-1.5">
        <BuildingIcon className="h-3 w-3 text-muted-foreground" />
      </div>
      <div>
        <h3 className="font-medium text-base">{company.name}</h3>
        <p className="text-base text-muted-foreground">{company.subtitle}</p>
      </div>
    </div>
  );
}
